import {
  RegisterOptions,
  useController,
  Control,
  FieldValues,
  Path,
} from "react-hook-form";
import TextInputWithSuggestion from "@components/TextInputWithSuggestion/TextInputWithSuggestion.tsx";

interface TextInputWithSuggestionsContainerProps<T, TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  title: string;
  rules?: Omit<
    RegisterOptions<TFieldValues>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  disabled?: boolean;
  useSuggestions: (search: string) => {
    data?: T[];
    isLoading: boolean;
    isFetching: boolean;
    isFetched: boolean;
    isError: boolean;
    refetch: () => void;
  };
  noSuggestionsMessage?: React.ReactNode;
  maxLength?: number;
  onSelect?: (value: T) => void;
  onInput?: (value: string) => void;
  getName?: (v: T) => string;
  getSelectionValue?: (v: T) => string;
  disabledMessage?: string;
}

const TextInputWithSuggestionsContainer = <T = string, TFieldValues extends FieldValues = FieldValues>(
  props: TextInputWithSuggestionsContainerProps<T, TFieldValues>,
) => {
  const { field, fieldState } = useController<TFieldValues>({
    control: props.control,
    name: props.name,
    rules: props.rules,
  });

  const maxLength = props.maxLength ?? 50;

  return (
    <TextInputWithSuggestion<T>
      value={field.value}
      onChange={field.onChange}
      name={field.name}
      title={props.title}
      errorMessage={fieldState.error?.message}
      hasError={!!fieldState.error}
      disabled={props.disabled}
      maxLength={maxLength}
      useSuggestions={props.useSuggestions}
      noSuggestionsMessage={props.noSuggestionsMessage}
      onSelect={props.onSelect}
      onInput={props.onInput}
      getName={props.getName}
      getSelectionValue={props.getSelectionValue}
      disabledMessage={props.disabledMessage}
    />
  );
};

export default TextInputWithSuggestionsContainer;
